module.exports = __webpack_public_path__ + "static/media/1.122ec346.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16015/1.jpg
// module id = 507
// module chunks = 0